import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../../src/environments/environment';
import { PortalPreferencesInterface } from '../../interfaces/portal-preferences.interface';
import { ISiteInfo } from '../../interfaces/isiteinfo.interface';
import { FeatureService } from '../feature/feature.service';
import { RestApiService } from '../rest-api/rest-api.service';
import { merge } from 'lodash';
import { Course } from 'models/course';
@Injectable()
export class ConfigurationService {
    public $siteSettings: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $portalSiteSettings: BehaviorSubject<any> = new BehaviorSubject(null);
    public $portalPreferences: BehaviorSubject<PortalPreferencesInterface> = new BehaviorSubject(null);
    public $siteSettingsByCountry: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $globalSettings: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $allSalutationsByLanguage: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $allCountriesByLanguage: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $globalConfiguration: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $partnerConfiguration: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $countriesData: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    public $isPreview: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public $coursesPerPage: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public priceValue: string;
    public currency: string;
    public course: Course;
    private _$portalVersion: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private siteInfos = new Map<string, ISiteInfo>();
    private _configs = new Map<string, any>();
    private _$isSiteLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private metaData: any;
    private sortOptions: any;
    private searchWidget: any;
    private yearsOptions: any;
    private monthsOptions: any;
    private courseTypeFilterOptions: any;
    private _$currentPortal: BehaviorSubject<string> = new BehaviorSubject(null);
    public $hasFeature: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private isbillingContactEdited = false;
    private _$loggedInByPopup: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private _$portalLanguage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _$portalDefaultLanguage: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    private defaultSortValue: string = null;

    public siteSettingsList = [];
    public siteSettingsByCountryList = [];
    public configList = [];
    public CountriesAndSalutationsList = [];
    constructor(
        private _featureService: FeatureService,
        private _restApi: RestApiService,
        private _translateService: TranslateService,
        private _localizeRouterService: LocalizeRouterService,
        private _activatedRoute: ActivatedRoute
    ) {}

    public get portalLanguage$(): Observable<any> {
        return this._$portalLanguage.asObservable();
    }

    public get portalDefaultLanguage$(): Observable<string> {
        return this._$portalDefaultLanguage.asObservable();
    }

    public get portalVersion$(): Observable<any> {
        return this._$portalVersion.asObservable();
    }

    public get currentPortal$(): Observable<string> {
        return this._$currentPortal.asObservable();
    }

    public get portalPreferences$(): Observable<PortalPreferencesInterface> {
        return this.$portalPreferences.asObservable();
    }

    public get portalId() {
        return this._$currentPortal.getValue();
    }

    public get isSiteLoaded$(): Observable<boolean> {
        return this._$isSiteLoaded.asObservable();
    }

    public get siteSettings$(): Array<any> {
        return this.$siteSettings.getValue();
    }

    public get portalSiteSettings$(): any {
        return this.$portalSiteSettings.getValue();
    }

    public get siteSettingsByCountry$(): Array<any> {
        return this.$siteSettingsByCountry.getValue();
    }

    public get loggedInByPopup$(): boolean {
        return this._$loggedInByPopup.getValue();
    }

    public get countriesData$(): Array<any> {
        return this.$countriesData.getValue();
    }

    public get isPreview$(): boolean {
        return this.$isPreview.getValue();
    }

    public get coursesPerPage$(): boolean {
        return this.$coursesPerPage.getValue();
    }

    public get DefaultSortValue(): string {
        return this.defaultSortValue;
    }

    public get globalSettings$(): Array<any> {
        return this.$globalSettings.getValue();
    }

    public get allSalutationsByLanguage$(): Array<any> {
        return this.$allSalutationsByLanguage.getValue();
    }

    public get allCountriesByLanguage$(): Array<any> {
        return this.$allCountriesByLanguage.getValue();
    }

    public get globalConfiguration$(): Array<any> {
        return this.$globalConfiguration.getValue();
    }

    public get partnerConfiguration$(): Array<any> {
        return this.$partnerConfiguration.getValue();
    }

    public get ProductTabsSortAlphabetically(): string[] {
        return this._configs.get('ProductTabsSortAlphabetically'.toLowerCase());
    }

    public get BusinessFieldInfo(): any {
        return this._configs.get('BusinessFieldInfo'.toLowerCase());
    }

    public get MetaData() {
        return this.metaData;
    }

    public get SortOptions() {
        return this.sortOptions;
    }

    public get SearchWidget() {
        return this.searchWidget;
    }

    public get MonthsOptions() {
        return this.monthsOptions;
    }

    public get YearsOptions() {
        return this.yearsOptions;
    }

    public get CourseTypeFilterOptions() {
        return this.courseTypeFilterOptions;
    }

    public get SiteSettings() {
        return this._configs.get('SiteSettings'.toLowerCase());
    }

    public get isBillingContactEdited() {
        return this.isbillingContactEdited;
    }

    public isSelectionPage(): boolean {
        // window.location.pathname === '/' ||
        return (
            window.location.href.toLowerCase().indexOf('countryselection') >= 0 ||
            window.location.href.toLowerCase().indexOf('generalterms') >= 0 ||
            window.location.href.toLowerCase().indexOf('dataprotection') >= 0 ||
            window.location.href.toLowerCase().indexOf('legalnotice') >= 0 ||
            window.location.href.toLowerCase().indexOf('transparencyselection') >= 0 ||
            window.location.href.toLowerCase().indexOf('licensesselection') >= 0 ||
            window.location.href.toLowerCase().indexOf('supplieridentification') >= 0 ||
            window.location.href.toLowerCase().indexOf('noticeselection') >= 0 ||
            window.location.href.toLowerCase().indexOf('termsandconditionsofsaleselection') >= 0
        );
    }

    public isPartnerPage(): boolean {
        return window.location.href.toLowerCase().indexOf('partner') >= 0;
    }

    public getSiteFromUrl() {
        const paths: string[] = location.pathname.split('/').splice(1, 1);
        const basePath: string = (paths && paths[0]) || ''; // Default: root domain
        return this.$globalSettings.getValue().find((x) => x.site.toLowerCase() === basePath.toLowerCase());
    }

    public getConfigByLanguage() {
        const _site = this.getCurrentSite();
        if (_site) {
            const _url = `${environment.locales}assets/config/${_site}.json`;
            // const _url = `${environment.APIEndpoint}api/v1/Config/site/${_site}`;
            return this._restApi.requestGET<any>(_url).then(
                (data) => {
                    return data.siteSettings;
                },
                (error) => {
                    console.log(`Error: no configuraton found for ${_site}`);
                }
            );
        }
    }

    public getSortOptions(lang) {
                const _urlKeywords = `${environment.APIEndpoint}api/v1/Translations/Keyword/${lang}`;
                const _promises: Array<Promise<any>> = [];
                const p1 = this._restApi.requestGET<any>(_urlKeywords);
                _promises.push(p1);

                return Promise.all(_promises).then((values) => {
                    this.sortOptions = values;
                    return this.sortOptions;
                });
    }

    public getConfigPartnerByPortal(portalId?: string) {
        const currentPortal = portalId || this._$currentPortal.getValue();
        if (currentPortal) {
            const _url = `${environment.locales}assets/config/partner/${currentPortal}.json`;
            const loaded = this.siteSettingsList.find(x => x.key === currentPortal);
            if (loaded) {
                return Promise.resolve(loaded.value);

            } else {
                return this._restApi.requestGET<any>(_url).then(
                    (data) => {
                        this.siteSettingsList.push({
                            key: currentPortal,
                            value: data.siteSettings
                        });
                        return data.siteSettings;
                    },
                    (error) => {
                        return null;
                        console.log(`Error: no configuraton found for ${currentPortal}`);
                    }
                );
            }
        }
    }

    public getCurrentSite() {
        const language = this.getSiteFromUrl();
        const _localizeLanguage = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE');
        return _localizeLanguage ? _localizeLanguage : language ? language.site : 'en_uk';
    }

    public hasFeature(name: string) {
        return this._featureService.has(name);
    }

    public getSiteInfos(): Map<string, ISiteInfo> {
        return new Map(this.siteInfos);
    }

    public getSiteInfo(site: string) {
        return this.siteInfos.has(site) ? this.siteInfos.get(site).locale : 'en-GB';
    }

    public getSiteLocale(site: string) {
        return this.siteInfos.has(site) ? this.siteInfos.get(site).locale : 'en-GB';
    }

    public getAllLocales() {
        const locales: Map<string, string> = new Map();
        this.siteInfos.forEach((site, key) => {
            locales.set(key, site.locale);
        });
        return locales; // Array<SITES, LOCALE>
    }

    public getAllSites(): Array<string> {
        return Array.from(this.siteInfos.keys());
    }

    public getAllLanguagesByLocale(): Array<string> {
        const _return: Array<string> = [];
        this.siteInfos.forEach((data, key) => {
            const _lang = data.locale.split('-');
            if (_return.indexOf(_lang[0]) === -1) {
                _return.push(_lang[0]);
            }
        });
        return _return;
    }

    private _loadGlobal(_urlGlobal) {
        const loaded = this.configList.find(x => x.key === _urlGlobal);
        if (loaded) {
            return Promise.resolve(loaded.value);
        } else {
            return this._restApi.requestGET<any>(_urlGlobal).then(
                (data) => {
                    this.configList.push({
                        key: _urlGlobal,
                        value: data
                    });
                    return data;
                },
                (error) => {
                    return null;
                    console.log(`Error: no configuraton found for ${_urlGlobal}`);
                }
            );
        }
    }

    private _loadUrlConfig(_url) {
        const loaded = this.configList.find(x => x.key === _url);
        if (loaded) {
            return Promise.resolve(loaded.value);
        } else {
            return this._restApi.requestGET<any>(_url).then(
                (data) => {
                    this.configList.push({
                        key: _url,
                        value: data
                    });
                    return data;
                },
                (error) => {
                    return null;
                    console.log(`Error: no configuraton found for ${_url}`);
                }
            );
        }
    }

    public loadConfiguration(isPortal): Promise<any> {
        const _site = isPortal ? 'partner' : this.getCurrentSite();
        const _url = `${environment.locales}assets/config/${_site}.json`;
        // let _url = `${environment.APIEndpoint}api/v1/Config/site/${_site}`;

        // let _urlGlobal = `${environment.locales}assets/config/global.json`;
        const _urlGlobal = `${environment.APIEndpoint}api/v1/Config/global`;

        const _promises: Array<Promise<any>> = [];
        const p1 = this._loadUrlConfig(_url);
        const p2 = this._loadGlobal(_urlGlobal);
        _promises.push(p1, p2);

        return Promise.all(_promises)
            .then((values) => {
                if (values) {
                    this.$siteSettings.next(values[0].siteSettings);
                    this.metaData = values[0].siteSettings.filter((setting) => setting.key.toLowerCase() === 'metadata');
                    this.searchWidget = values[0].siteSettings.filter((setting) => setting.key.toLowerCase() === 'SearchWidget');
                    this.courseTypeFilterOptions = values[0].siteSettings.filter(
                        (setting) => setting.key.toLowerCase() === 'filtercoursetype'
                    );
                    this.monthsOptions = values[0].siteSettings.filter((setting) => setting.key.toLowerCase() === 'months');
                    this.yearsOptions = values[0].siteSettings.filter((setting) => setting.key.toLowerCase() === 'years');

                    if (isPortal) {
                        const _lang = JSON.parse(sessionStorage.getItem('portalLang')).lang;
                        const _languageSetting = values[0].siteSettings.filter((lang) => lang.key.toLowerCase() === _lang);
                        this.monthsOptions = _languageSetting[0].value.filter((setting) => setting.key.toLowerCase() === 'months');
                        this.yearsOptions = _languageSetting[0].value.filter((setting) => setting.key.toLowerCase() === 'years');
                    }
                    this.$isPreview.next(values[1].preview);
                    this.$coursesPerPage.next(values[1].siteSettings[2].value[0].numberOfItems);
                    this.$countriesData.next(values[1].siteSettings[0].value);
                    this.$globalConfiguration.next(values[1].siteSettings);
                    this.defaultSortValue = values[0].siteSettings.filter(
                        (setting) => setting.key.toLowerCase() === 'defaultsortvalue'
                    )[0]?.value;
                    if (isPortal) {
                        this.defaultSortValue = 'bestseller';
                    }
                    const _siteSettings = [];
                    values[1].siteSettings[0].value.forEach((i) => {
                        i.Items.forEach((j) => {
                            j.LinkList.forEach((k) => {
                                _siteSettings.push(k);
                            });
                        });
                    });
                    this.$globalSettings.next(_siteSettings);
                    this._parseFeatures(values).then(() => {
                        setTimeout(() => this._$isSiteLoaded.next(true));
                    });
                }
            })
            .catch<any>((error) => {
                if (error.status) {
                    this._restApi.fireStatus(error.status, {
                        type: 'ConfigurationService',
                        error: error
                    });
                }
            });
    }

    public loadConfigurationByCountry(url): Promise<any> {
        let _url = `${environment.locales}assets/i18n/${url}.json`;

        // let _url = `${environment.locales}assets/i18n/${_site}.json`;
        //let _url = `${environment.APIEndpoint}api/v1/Config/site/${_site}`;
        // let _url = `${environment.APIEndpoint}api/v1/config/${_site}/getsitetranslation`;
        const p = this._restApi.requestGET<any>(_url);

        const loaded = this.siteSettingsList.find(x => x.key === url);
        if (loaded) {
            return Promise.resolve(loaded.value);

        } else {
            return p.then(
                (data) => {
                    this.siteSettingsList.push({
                        key: url,
                        value: data
                    });
                    this.$siteSettingsByCountry.next(data);
                },
                (error) => {
                    console.log(`Error: no configuraton found for ${_url}`);
                }
            );
        }
    }

    public triggerLanguageChangeAndReloadAll(site, isPortal: boolean): Promise<any> {
        if (!isPortal) {
            this._translateService.use(site);
            this._localizeRouterService.changeLanguage(site);
            return this.loadConfiguration(false).then((data) => data);
        } else {
            return this.setTranslationsAndSettings(this._$currentPortal.getValue(), site).then((settings) => {
                return settings;
            });
        }
    }

    public setPortal(portalId: string): void {
        this._$currentPortal.next(portalId);
    }

    public setPortalSettings(siteSettings: any): void {
        this.$portalSiteSettings.next(siteSettings);
    }

    setPortalPreferences(config: PortalPreferencesInterface) {
        this._$portalDefaultLanguage.next(config['defaultLanguage']);
        this.$portalPreferences.next(config);
    }

    public setPortalVersion(version: string) {
        this._$portalVersion.next(version);
    }

    public getPortalVersion(): Observable<string> {
        return this._$portalVersion.asObservable();
    }

    setTranslationsAndSettings(portal: string, _language: string): Promise<any> {
        const _promises: Array<Promise<any>> = [];
        let language = 'default';
        if (_language) {
            language = _language.toLowerCase();
        }
        const p1 = this._restApi.requestGET('assets/i18n/portals/' + language + '.json');
        const p2 = this._restApi.requestGET('assets/i18n/portals/' + portal + '.json');
        return Promise.all([p1, p2])
            .then((value) => {
                if (language.length === 2) {
                    const defaultLanguage = value[0][language][0];
                    const specificPortal = value[1][language][0];
                    const mergedTranslationFile = merge(defaultLanguage, specificPortal);
                    const config = { [language]: [mergedTranslationFile] };
                    let _lang = _language.toLowerCase();
                    if (!config[_lang]) {
                        _lang = this._$portalDefaultLanguage.getValue().toLowerCase();
                    }
                    this.setPortalLanguage(_lang, portal);
                    this._translateService.setTranslation(_lang.toLowerCase(), config[_lang.toLowerCase()][0], true);
                    this._translateService.use(_lang);
                    this.setPortalSettings(config[_lang.toLowerCase()][0]);
                    return config;
                }
            })
            .catch((err) => {
                return Promise.resolve([]);
            });
    }

    public setPortalLanguage(lang: string, portalId: string): void {
        this._$portalLanguage.next(lang.toLowerCase());
        if (sessionStorage) {
            sessionStorage.setItem('portalLang', JSON.stringify({ portalId: portalId, lang: lang.toLowerCase() }));
        }
    }

    private _parseFeatures(siteSettings: any): Promise<boolean> {
        let localFeatures = siteSettings[0].siteSettings.filter((setting) => setting.key === 'features');
        let globalFeatures = siteSettings[1].siteSettings.filter((setting) => setting.key === 'features');
        if (localFeatures.length <= 0) {
            localFeatures = [
                {
                    key: 'features',
                    value: []
                }
            ];
        }
        const isPreview = this.$isPreview.getValue();
        globalFeatures[0].value.map((globalFeature) => {
            const localFeature = localFeatures[0].value.filter((localFeature) => {
                return localFeature.name.toLowerCase() === globalFeature.name.toLowerCase();
            });
            // (p && s) || (g && s)
            const _featureIsEnabled =
                (globalFeature.name === 'Partner' && globalFeature.enabled) ||
                (isPreview && localFeature[0] && localFeature[0].enabled) ||
                (globalFeature.enabled && localFeature[0] && localFeature[0].enabled);
            this._featureService.setFeature(globalFeature.name, _featureIsEnabled);
        });
        return Promise.resolve(true);
    }
    
    public checkIfCurrencyIsDifferentToCartItemsCurrency(siteOrPortal, currency) {
        if (localStorage.getItem(`currencyOfCartItems${siteOrPortal}`)) {
            if (localStorage.getItem(`currencyOfCartItems${siteOrPortal}`) === currency) {
                return true;
            } else {
                return false;
            }
        } else {
            localStorage.setItem(`currencyOfCartItems${siteOrPortal}`, currency);
            return true;
        }
    }

    public formatPrice(price: number, formatPattern, currency){
        this.priceValue = price?.toString();
        if (this.priceValue) {
            if (formatPattern.includes('#,##')) {
                this.insertSeparators(this.priceValue, ',');
            } else if (formatPattern.includes('#.##')) {
                this.insertSeparators(this.priceValue, '.');
            }

            if ((this.priceValue[this.priceValue.length -3] !== '.' && this.priceValue[this.priceValue.length -2] !== '.') && formatPattern.includes('0,00')) {
                this.priceValue = this.priceValue + ',00';
            } else if ((this.priceValue[this.priceValue.length -3] === '.' || this.priceValue[this.priceValue.length -2] === '.') && formatPattern.includes('0,00')) {
                if (this.priceValue[this.priceValue.length -2] === '.') {
                    this.priceValue = this.priceValue + '0';
                    const beforeDecimal = this.priceValue.substring(0, this.priceValue.length - 3)
                    const decimal = this.priceValue.slice(3, this.priceValue.length);
                    this.priceValue = beforeDecimal + ',' + decimal;
                } else {
                    this.priceValue.slice(1, this.priceValue.length -2) + ',' + this.priceValue.slice(this.priceValue.length -2);
                }
            } else if ((this.priceValue[this.priceValue.length -3] !== '.' && this.priceValue[this.priceValue.length -2] !== '.') && formatPattern.includes('0.00')) {
                this.priceValue = this.priceValue + '.00';
            } else if ((this.priceValue[this.priceValue.length -3] === '.' || this.priceValue[this.priceValue.length -2] === '.') && formatPattern.includes('0.00')) {
                if (this.priceValue[this.priceValue.length -2] === '.') {
                    this.priceValue = this.priceValue + '0';
                    const beforeDecimal = this.priceValue.substring(0, this.priceValue.length - 3)
                    const decimal = this.priceValue.slice(3, this.priceValue.length);
                    this.priceValue = beforeDecimal + '.' + decimal;
                }
            }
        }

        const formatPatternArrray = formatPattern.split('');
        
        this.currency = currency;

        if (formatPatternArrray[formatPatternArrray.length -1] === '"' && formatPatternArrray[formatPatternArrray.length -3] === '"') {
            return this.priceValue + this.currency;
        } else if (formatPatternArrray[formatPatternArrray.length -1] === '"' && formatPatternArrray[formatPatternArrray.length -3] === ' ') {
            return this.priceValue + ' ' + this.currency;
        } else if (formatPatternArrray[0] === '"' && formatPatternArrray[2] === '"') {
            return this.currency + this.priceValue;
        } else if (formatPatternArrray[0] === '"' && formatPatternArrray[2] === ' ' ) {
            return this.currency + ' ' + this.priceValue;
        }
    }

    private insertSeparators(priceValue, seperator) {
        if (priceValue > 999999) {
            priceValue = priceValue.slice(0, priceValue.length -6) + seperator + priceValue.slice(priceValue.length -6);
            priceValue = priceValue.slice(0, priceValue.length -3) + seperator + priceValue.slice(priceValue.length -3);
            this.priceValue = priceValue;
        } else if (priceValue > 999) {
            priceValue = priceValue.slice(0, priceValue.length -3) + seperator + priceValue.slice(priceValue.length -3);
            this.priceValue = priceValue;
        }
    }

    public updateIfBillingContactEdited(value) {
        this.isbillingContactEdited = value;
    }

    public getCountriesAndSalutationsByLanguage(lang): Promise<any> {
        const loaded = this.CountriesAndSalutationsList.find(x => x.key === lang);
        if (loaded) {
            this.$allSalutationsByLanguage.next(loaded.value[0]);
            this.$allCountriesByLanguage.next(loaded.value[1]);
            return Promise.resolve(loaded.value);
        } else {
            const _urlSalutations = `${environment.APIEndpoint}api/v1/Translations/Salutation/${lang}`;
            const _urlCountries = `${environment.APIEndpoint}api/v1/Translations/Country/${lang}`;
            const _promises: Array<Promise<any>> = [];
            const p1 = this._restApi.requestGET<any>(_urlSalutations);
            const p2 = this._restApi.requestGET<any>(_urlCountries);
            _promises.push(p1, p2);

            return Promise.all(_promises).then((values) => {
                const sortedSalutations = [];
                sortedSalutations.push(values[0][1]);
                sortedSalutations.push(values[0][0]);
                this.CountriesAndSalutationsList.push({
                    key: lang,
                    value: [sortedSalutations, values[1]]
                });
                this.$allSalutationsByLanguage.next(sortedSalutations);
                this.$allCountriesByLanguage.next(values[1]);
            });
        }
    }

    public updateloggedInByPopup(value) {
        this._$loggedInByPopup.next(value);
        return this._$loggedInByPopup.getValue();
    }
}
